import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import styles from "./city-select-menu.module.scss";
import CityCardSmall from "../city-cards/city-card-small/city-card-small";
import SearchBar from "../../../ui-kit/search-bar/search-bar";
import { useAppDispatch } from "../../../../hooks/useAppDispatch";
import { useAppSelector } from "../../../../hooks/useAppSelector";
import {
  selectFilteredCities,
  setSearchValue,
} from "../../../../services/reducers/cities";
import CustomScrollbar from "../../../ui-kit/scrollbar/scrollbar";
import usePopStateScroll from "../../../../hooks/usePopStateScroll";
import {LayersDataTypes} from "../../../../types/layers-data-types";
import {setLayersVisible} from "../../../../services/reducers/map";

export const CitySelectMenu = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { searchValue } = useAppSelector((store) => store.cities);
  const { layersIds, visibleLayersId } = useAppSelector(state => state.map)
  const filteredCities = useAppSelector(selectFilteredCities);

  usePopStateScroll({ param: 'eid', prefix: 'cities-closed-card-' });

  useEffect(() => {
    const cityIds = layersIds[LayersDataTypes.CityBoundary] || [];
    const hasMissingCityBoundaryIds  = cityIds.some(id => !visibleLayersId.includes(id));
    if (hasMissingCityBoundaryIds) {
      dispatch(setLayersVisible([
        ...visibleLayersId,
        ...cityIds
      ]));
    }
  }, []);

  return (
    <div style={{ position: "relative", height: "100%" }}>
      <div className={styles.citySelectMenu}>
      <div className={styles.staticContent}>
        <h2 className={styles.title}>
          {t('city-card.citySelect.title')}
          <span className={filteredCities.length && searchValue ? styles.resultFound : styles.available}>
            {filteredCities.length} 
            {filteredCities.length === 1
              ? ` ${t('city-card.citySelect.cityAvailable')}`
              : ` ${t('city-card.citySelect.citiesAvailable')}`}
          </span>
        </h2>
        <SearchBar
          className={styles.search}
          placeholder={t('city-card.citySelect.searchPlaceholder')}
          searchValue={searchValue}
          onSearchChange={(event) =>
            dispatch(setSearchValue(event.currentTarget.value))
          }
          onClearSearch={() => dispatch(setSearchValue(""))}
        />
            </div>
        <CustomScrollbar marginRight='13px'>
          <div className={styles.cards}>
            {filteredCities.length > 0 ? (
                filteredCities.map((item) => (
                    <CityCardSmall
                        key={item.estateEn}
                        city={item}
                    />
                ))
            ) : (
                <div className={styles.noMatchesFound}>
                  <span>{t('city-card.citySelect.noMatches')}</span>
                  <br />
                  <span>{t('city-card.citySelect.tryAgain')}</span>
                </div>
            )}
          </div>
        </CustomScrollbar>
      </div>
    </div>
  );
};

export default CitySelectMenu;
